import React, { useState, useEffect } from 'react'
import './Post.css'
import { db } from './firebase'
import Avatar from "@material-ui/core/Avatar"
import firebase from 'firebase';

function Post({postId, user, username, caption, imageUrl}) {
    const [comments, setComments] = useState([]);
    const [comment, setComment] = useState('');

    const postComment = (event) => {
        event.preventDefault();

        db.collection("posts").doc(postId).collection("comments").add({
            text: comment,
            user: user.displayName,
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
        setComment('')
    }

    useEffect(() => {
        let unsubscribe;
        if (postId) {
            unsubscribe = db
            .collection("posts")
            .doc(postId)
            .collection("comments")
            .orderBy('timestamp', 'desc')
            .onSnapshot((snapshot) => {
                setComments(snapshot.docs.map((doc) => doc.data()));
            });
        }

        return () => {
            unsubscribe();
        };
    }, [postId]);
    return (
        <div className="post">
            <div className="post__header">
              <Avatar
                  className="post__avatar"
                  alt={username}
                  src="/static/images/avatar/1.png"
              /> 
              <h4>{username}</h4>
            </div>
            
            {/* header -> avatar + username */}

            <img className="post__image" src={imageUrl} alt=""/>
            {/* image */}

            <h4 className="post__text"><strong></strong>{caption}</h4>
            {/* username + caption */}

            <div className="post__comments">
                {comments.map((comment) => (
                    <p> 
                        <strong> {comment.user}</strong> {comment.text}
                    </p>
                ))}
            </div>

    {user && (
        <form className="post__commentBox">
            <input
            className="post__input"
            type="text"
            placeholder="Enter a comment"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            />
            <button
            className="post__button"
            disabled={!comment}
            type="submit"
            onClick={postComment}
            >
                Post
            </button>
        </form>
    )}

        
        </div>
    )
}

export default Post
